'use client';
import { PropsWithChildren } from 'react';

export default ({ children }: PropsWithChildren) => <>{children}</>;
